import app from 'app';
import templateUrl from './familyAccessEdit.html';
import { COLLECTIVE_TITLE } from '../../../collectiveTitle';

import { logEvent, eventCategories } from 'helpers/analytics';

function familyAccessEdit($stateParams, animatedScrollTop, PhiAuthorization) {
  const FamilyAccessEdit = this;
  FamilyAccessEdit.COLLECTIVE_TITLE = COLLECTIVE_TITLE;

  function setLevelOptions(primaryName) {
    FamilyAccessEdit.levelOptions = [
      {
        label: 'Basic Access',
        subLabel: `Allows ${primaryName} to see and discuss only basic information about the care you receive, including
          a general category name (e.g. medical, pharmacy, dental, or vision, as applicable), the date of service, and
          cost. Note: The primary subscriber and any designees automatically have this access in order to manage the
          payments of care.`,
        value: 'NO_PHI'
      },
      {
        label: 'Limited Access',
        subLabel: `Allows ${primaryName} to see only Basic Access information on their ${COLLECTIVE_TITLE} account
          and allows ${primaryName} to discuss your healthcare information as allowed under Full Access, EXCEPT
          sensitive care information (e.g. mental health, sexual, or substance abuse-related care) with Collective
          Health member advocates. NOTE: Limited Access is the DEFAULT information access for parents, subscribers, and
          legal guardians for all members ages 13-17.`,
        value: 'LIMITED_PHI'
      },
      {
        label: 'Full Access',
        subLabel: `Allows ${primaryName} to see and discuss all of your
          healthcare information, including specific descriptions of care, dates of care, costs for care, provider
          names, prescriptions, and the details of your claims submitted to Collective Health.
          ${primaryName} will also be notified of new claims when they come in.`,
        value: 'FULL_PHI'
      }
    ];
  }

  function handleAnalyticsEvent(success) {
    if (success) {
      let analyticsLabel;
      switch (FamilyAccessEdit.level) {
        case 'NO_PHI':
          analyticsLabel = 'Basic';
          break;
        case 'LIMITED_PHI':
          analyticsLabel = 'Limited';
          break;
        case 'FULL_PHI':
          analyticsLabel = 'Full';
          break;
        default:
          break;
      }

      logEvent('familyAccessEdited', {
        category: eventCategories.SETTINGS,
        accessLevel: analyticsLabel
      });
    }
  }

  function handleServerError(err) {
    handleAnalyticsEvent();

    FamilyAccessEdit.toast.show = true;
    FamilyAccessEdit.toast.type = 'error';
    FamilyAccessEdit.toast.errorCode = err.data.errorNumber;
    FamilyAccessEdit.toast.errorText = err.data.errorMessage;
    animatedScrollTop();
  }

  function handleServerSuccess() {
    FamilyAccessEdit.toast.show = true;
    FamilyAccessEdit.toast.type = 'success';
    FamilyAccessEdit.toast.errorCode = null;
    FamilyAccessEdit.toast.errorText = 'Family access & authorization saved.';
    animatedScrollTop();
  }

  function getToastDefaults() {
    return {
      show: false,
      type: 'success',
      errorCode: 0,
      errorText: ''
    };
  }

  FamilyAccessEdit.$onInit = () => {
    FamilyAccessEdit.toast = getToastDefaults();

    PhiAuthorization.getAuthorizations({
      granteeId: $stateParams.granteeId,
      grantorId: FamilyAccessEdit.currentUser.user.id,
      useFamilyUnitDefaults: true
    }).then(resp => {
      FamilyAccessEdit.authorization = resp.phiAuthorizations[0];
      FamilyAccessEdit.level = FamilyAccessEdit.authorization.phiLevel;

      setLevelOptions(FamilyAccessEdit.authorization.grantee.firstName);
    });
  };

  FamilyAccessEdit.save = () => {
    let phiAuthPromise;

    if (FamilyAccessEdit.authorization.id) {
      phiAuthPromise = PhiAuthorization.putAuthorizations({
        phiAuthorizationId: FamilyAccessEdit.authorization.id,
        phiLevel: FamilyAccessEdit.level
      });
    } else {
      phiAuthPromise = PhiAuthorization.postAuthorizations({
        granteeId: FamilyAccessEdit.authorization.grantee.id,
        grantorId: FamilyAccessEdit.authorization.grantor.id,
        phiLevel: FamilyAccessEdit.level
      });
    }

    phiAuthPromise
      .then(resp => {
        handleAnalyticsEvent(true);

        FamilyAccessEdit.authorization = resp.phiAuthorization;
        handleServerSuccess();
      })
      .catch(handleServerError)
      .finally(() => {
        FamilyAccessEdit.accessLevel.$setPristine();
      });
  };

  FamilyAccessEdit.dismissError = () => {
    FamilyAccessEdit.toast = getToastDefaults();
  };

  FamilyAccessEdit.reset = function() {
    FamilyAccessEdit.level = FamilyAccessEdit.authorization.phiLevel;
    FamilyAccessEdit.accessLevel.$setPristine();
  };
}

app.component('familyAccessEdit', {
  bindings: {
    currentUser: '<'
  },
  controller: familyAccessEdit,
  controllerAs: 'FamilyAccessEdit',
  templateUrl: templateUrl
});

export default 'familyAccessEdit';
